<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="被推荐人姓名"
            :label-width="formLabelWidth"
            prop="customerName"
          >
            <el-input
              class="search-input"
              v-model="form.customerName"
              clearable
              placeholder="请输入被推荐人姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="被推荐人电话"
            prop="customerPhone"
          >
            <el-input
              class="search-input"
              v-model="form.customerPhone"
              clearable
              placeholder="请输入被推荐人电话"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="所在城市"
            :label-width="formLabelWidth"
            prop="areaName"
          >
            <el-cascader
              ref="unitAreacode"
              size="large"
              :options="options"
              v-model="selectedOptions"
              @change="handleChange"
              clearable
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="物业名称"
            :label-width="formLabelWidth"
            prop="companyName"
          >
            <el-input
              class="search-input"
              v-model="form.companyName"
              clearable
              placeholder="请输入物业名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="推荐人姓名"
            prop="userId"
          >
            <!-- <el-input
              class="search-input"
              v-model="form.userId"
              placeholder="请输入推荐人姓名"
            ></el-input> -->
            <el-select
              class="select"
              v-model="form.userId"
              filterable
              remote
              placeholder="请输入推荐人姓名"
              :remote-method="searchUser"
              @change="checkItem"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="推荐人电话"
            prop="userMobile"
          >
            <el-input
              class="search-input"
              v-model="form.userMobile"
              clearable
              placeholder="请输入推荐人电话"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="推荐物业业态"
            :label-width="formLabelWidth"
            prop="typeName"
          >
            <el-select
              class="search-select1"
              v-model="form.typeName"
              placeholder="请选择推荐物业业态"
              clearable
              multiple
            >
              <el-option
                v-for="item in typeList"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="推荐时间"
            :label-width="formLabelWidth"
            prop="appointmentTime"
          >
            <!--  HH:mm:ss -->
            <!-- <el-date-picker
              v-model="appointmentTime"
              type="date"
              autocomplete="off"
              placeholder="请选择推荐时间"
              value-format="yyyy-MM-dd"
              clearable
            ></el-date-picker> -->
            <el-date-picker
              v-model="appointmentTime"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="btn">
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <PermissionsBtn
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/PmcIntroduce/downLoad'"
              :checkList="checkList"
              :form="exportForm"
            ></PermissionsBtn>
            <!-- <el-button
              size="small"
              type="success"
              @click="isExpend = !isExpend"
              >{{ !isExpend ? '展开' : '收起' }}</el-button
            > -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { regionData } from 'element-china-area-data';
import { getUserModelApi, getPmcTypeApi } from '@/api/user.js';
import { decrypt, encrypt } from '@/utils/encryp';
export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      // 表单内容
      form: {
        customerName: '',
        customerPhone: '',
        companyName: '',
        areaName: '',
        userId: '',
        userMobile: '',
        typeName: [],
        appointmentStartTime: '',
        appointmentEndTime: '',
      },
      appointmentTime: '',
      exportForm: {
        customerName: '',
        customerPhone: '',
        companyName: '',
        areaName: '',
        userId: '',
        userMobile: '',
        typeName: '',
      },
      loading: false,
      userList: [],
      typeList: [],
      options: regionData,
      selectedOptions: [],
      isExpend: false,
    };
  },
  computed: {
    ...mapGetters(['pickerOptions']),
  },
  watch: {},
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.getPmcType();
  },
  methods: {
    // 获取物业业态枚举
    async getPmcType() {
      try {
        let res = await getPmcTypeApi();
        if (res.code !== 200) return;
        this.typeList = res.data;
        // console.log('res', this.typeList);
      } catch (error) {
        console.log(error);
      }
    },
    // 选择城市
    handleChange(value) {
      console.log(value);
      // console.log('选择城市：', this.selectedOptions);
      // console.log(this.$refs.unitAreacode.getCheckedNodes()[0].pathLabels);
      if (value.length) {
        this.form.areaName =
          this.$refs.unitAreacode.getCheckedNodes()[0].pathLabels[2];
      } else {
        this.form.areaName = '';
      }
    },
    // 租购下拉选择
    handleSlectIntention(val) {
      // this.form.isSale = val > 1;
      // console.log(this.form.isSale);
      console.log(val);
    },
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.userList = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选项
    checkItem(val) {
      this.form.userId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      let {
        customerName,
        customerPhone,
        companyName,
        areaName,
        userId,
        userMobile,
      } = this.form;

      this.$emit('search', {
        customerName: customerName ? encrypt(customerName) : '',
        customerPhone: customerPhone ? encrypt(customerPhone) : '',
        companyName,
        areaName,
        userId,
        userMobile: userMobile ? encrypt(userMobile) : '',
        typeName: this.form.typeName ? this.form.typeName.join(',') : '',
        appointmentStartTime:
          (this.appointmentTime && this.appointmentTime[0]) || '',
        appointmentEndTime:
          (this.appointmentTime && this.appointmentTime[1]) || '',
      });
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.appointmentTime = [];
      this.selectedOptions = [];
      this.$refs[formName].resetFields();
      this.form = {};
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.search-select1 {
  // width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
